import { render } from "./CampaignDetails.vue?vue&type=template&id=b66334dc&ts=true"
import script from "./CampaignDetails.vue?vue&type=script&lang=ts"
export * from "./CampaignDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__